<template>
  <b-row>
    <b-col cols="12">
      <left-tabs :tabs="tabs" menu="tipo">
        <template #new-sale>
          <new-sale />
        </template>
        <template #readjustment>
          <readjustment />
        </template>
      </left-tabs>
    </b-col>
  </b-row>
</template>

<script>
import LeftTabs from "../Components/LeftTabs.vue";

import NewSale from "./sale/new-sale.vue";
import Readjustment from "./sale/readjustment.vue";

import permission from "../../lib/permission";

export default {
  name: "Sale",

  components: {
    LeftTabs,
    NewSale,
    Readjustment,
  },

  created() {
    this.retrieve();
  },

  data() {
    return {
      step: "new-sale",

      tabs: [],
    };
  },

  methods: {
    permission,

    async retrieve() {
      if (permission("write", "rest_home_transfer_medicine_resident")) {
        this.tabs.push({ title: "VENDA", step: "new-sale" });
      }

      // if (
      //   permission("read", "readjustment_service") ||
      //   permission("read", "readjustment_type_of_hosting")
      // ) {
      //   this.tabs.push({
      //     title: "REAJUSTE",
      //     step: "readjustment",
      //   });
      // }

      let { menu, tipo, item } = this.$router.currentRoute.query;

      if (!["new-sale", "readjustment"].includes(tipo)) {
        this.$router.replace({ query: { menu, tipo: "new-sale" } });
        this.step = "new-sale";
      } else {
        this.step = item;
      }
    },
  },
};
</script>